import { render, staticRenderFns } from "./infor.vue?vue&type=template&id=2db86e6e&scoped=true"
import script from "./infor.vue?vue&type=script&lang=js"
export * from "./infor.vue?vue&type=script&lang=js"
import style0 from "./infor.vue?vue&type=style&index=0&id=2db86e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db86e6e",
  null
  
)

export default component.exports